import React from 'react';
import { Dialog, DialogTitle } from 'material-ui';
import { CSVLink } from 'react-csv';

import IconButton from 'material-ui/IconButton';
import Close from 'material-ui-icons/Cancel';
import Download from 'material-ui-icons/FileDownload';

import Table from '../../helpers/AlertTable';

import buildVXCPortfolioAlertsCsvData from '../../helpers/vxc/reports/csv/buildAlertReportData';

const PostFrame = (props) => {
  const columns = [
    { name: 'portfolio', title: 'Portfolio' },
    { name: 'brand', title: 'Alert Type' },
    { name: 'financeCompanyName', title: 'Source' },
    { name: 'alerts', title: 'Alerts' },
    { name: 'vins', title: 'VINS' },
  ];
  const groupingColumn = [{ columnName: 'portfolio', showWhenGrouped: false }, { columnName: 'brand', showWhenGrouped: false }, { columnName: 'financeCompanyName', showWhenGrouped: true, expand: false }];
  const report = props.report ? props.report : [];
  report.forEach((el, index) => {
    el.portfolio = props.selectedPortfolio;
  });
  const date = new Date();
  const fileName = `PortfolioAlertsReport_for_${props.selectedCustomer}_${props.selectedPortfolio}_run_on_${date.toLocaleDateString().replace(/\//g, '_')}.csv`;
  return (
    <Dialog open={props.displayDialog} fullScreen>
      <DialogTitle style={{ height: '20px' }}>
        <IconButton style={{ float: 'right', marginTop: '-10px' }} title="close" component="span" onClick={o => props.hideModal()}>
          <Close color="disabled" />
        </IconButton>
      </DialogTitle>
      <div>
        <u><span style={{ marginLeft: 'calc(100% - 50%)' }}>{props.selectedCustomer}</span></u>
        <CSVLink
          data={buildVXCPortfolioAlertsCsvData(props.selectedPortfolio, report)}
          filename={fileName}
          style={{ color: 'white', float: 'right', marginRight: '5%' }}
        >
          <IconButton title="Click here to download" component="span" onClick={this.handleReportClick}>
            <Download color="disabled" />
          </IconButton>
        </CSVLink>
      </div>
      <div id="striped_table" align="center" style={{ marginBottom: '2%' }}>
        <Table columns={columns} rows={report} groupingColumn={groupingColumn} />
      </div>
    </Dialog>
  );
};

export default PostFrame;


// WEBPACK FOOTER //
// ./src/components/VXC/AlertReportPostFrame.js